import flatpickr from 'flatpickr';
import MonthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';

export default () => {
  // 日付入力でのInputマスクの読み込み
  $('[data-mask]').inputmask();

  // datetime picker
  flatpickr('.flatpickr-datetime-sec', {
    enableTime: true,
    dateFormat: 'Y/m/d H:i:S',
    defaultHour: 0,
    minuteIncrement: 1,
    enableSeconds: true,
    locale: Japanese,
    disableMobile: 'true',
  });
  flatpickr('.flatpickr-datetime', {
    enableTime: true,
    dateFormat: 'Y/m/d H:i',
    defaultHour: 0,
    minuteIncrement: 1,
    locale: Japanese,
  });
  flatpickr('.flatpickr-datetime-future', {
    enableTime: true,
    dateFormat: 'Y/m/d H:i',
    defaultHour: 0,
    minuteIncrement: 1,
    locale: Japanese,
    minDate: 'today',
  });
  flatpickr('.flatpickr-date', {
    dateFormat: 'Y/m/d',
    locale: Japanese,
  });
  const maxDate = new Date();
  const aMonthAgo = maxDate.setMonth(maxDate.getMonth() - 1);
  flatpickr('.flatpickr-month', {
    altInput: true,
    locale: Japanese,
    maxDate: aMonthAgo,
    plugins: [
      new MonthSelectPlugin({
        shorthand: false,
        altFormat: 'Y年 M',
        dateFormat: 'Y/m',
      }),
    ],
  });
};
